export const QA_NAME_APPLICANT_PROFILE_DOCUMENTS_FOLDER =
  'applicantDocumentsFolder'

export const APPLICANT_PROFILE_DOCUMENTS_BREADCRUMB_APPLICANT = 'applicant'
